var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2828_63313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.333 2.66797V6.66797H11.333",
    stroke: "#A0A0A0",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 13.332V9.33203H4.66699",
    stroke: "#A0A0A0",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34033 5.99842C2.67844 5.04295 3.25308 4.18869 4.01064 3.51537C4.76819 2.84205 5.68397 2.3716 6.67252 2.14793C7.66106 1.92426 8.69016 1.95465 9.66379 2.23627C10.6374 2.51789 11.5238 3.04157 12.2403 3.75842L15.3337 6.66509M0.666992 9.33176L3.76033 12.2384C4.47682 12.9553 5.36324 13.479 6.33687 13.7606C7.31049 14.0422 8.33959 14.0726 9.32813 13.8489C10.3167 13.6252 11.2325 13.1548 11.99 12.4815C12.7476 11.8082 13.3222 10.9539 13.6603 9.99842",
    stroke: "#A0A0A0",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2828_63313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshDisabled);
export default __webpack_public_path__ + "static/media/refresh-disabled.f797bbb0ebbd70c85ac0e4c664fb2c9b.svg";
export { ForwardRef as ReactComponent };